import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import InformationWindow from './informationWindow'

import { openMenu } from '../../store/common/commonSlice'
import { useHistory, useLocation } from 'react-router-dom'
import { RootState } from '../../store/rootReducer'

interface Props {
    loginDialog: boolean
    setLoginDialog: React.Dispatch<boolean>
    externalError?: string
}

const LoginDialog: React.FunctionComponent<Props> = ({ loginDialog, setLoginDialog, externalError }: Props) => {
    const [t] = useTranslation()
    const dispatch = useDispatch()
    const history = useHistory()
    const location = useLocation()
    const user = useSelector((state: RootState) => state.member.user)

    const notActive = () => user && !user.active

    const openMenuToLogin = () => {
        setLoginDialog(false)
        if (notActive()) {
            history.push(location.pathname + '?activate')
        }
        dispatch(openMenu())
    }

    return (
        <InformationWindow
            informationText={
                notActive()
                    ? t('You need to activate your account to use this feature')
                    : t('You need to be authorized to use this feature')
            }
            externalState={loginDialog}
            setExternalState={setLoginDialog}
            functionalButtonCallback={openMenuToLogin}
            labelFunctionalButton={notActive() ? t('Activate') : t('Log in')}
            closeButton={true}
            title={' '}
        />
    )
}

export default LoginDialog
